import React from 'react';

import { MainInfo } from './components/MainInfo';
import { ActivationInfo } from './components/ActivationInfo';

import { getLastUpdatedByCourses } from '../../StudentPage.helpers';

import styles from './SchoolStudentCard.module.scss';

const SchoolStudentCard = ({
  locale,
  student,
  studentStatus,
  studentCourses,
  onEditClick,
}: {
  locale: any;
  student: any;
  studentStatus: any;
  studentCourses: any;
  onEditClick: any;
}) => (
  <div className={styles.card}>
    <MainInfo
      {...student}
      locale={locale}
      status={studentStatus.status}
      updatedAt={getLastUpdatedByCourses(studentCourses)}
      onEditClick={onEditClick}
    />
    <ActivationInfo {...studentStatus} locale={locale} />
  </div>
);

export default React.memo(SchoolStudentCard) as any;
